"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.string.small");

var _breakpoints = _interopRequireDefault(require("../helpers/breakpoints"));

require("lazysizes/plugins/object-fit/ls.object-fit");

require("lazysizes/plugins/parent-fit/ls.parent-fit");

require("lazysizes/plugins/rias/ls.rias");

require("lazysizes/plugins/bgset/ls.bgset");

require("lazysizes");

require("lazysizes/plugins/respimg/ls.respimg");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Helper: Lazysizes
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for responsive and lazy loading images.
 *
 * @namespace lazysizes
 */


window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--tiny': "(min-width: ".concat(_breakpoints["default"].tiny, ")"),
  '--small': "(min-width: ".concat(_breakpoints["default"].small, ")"),
  '--medium': "(min-width: ".concat(_breakpoints["default"].medium, ")"),
  '--large': "(min-width: ".concat(_breakpoints["default"].large, ")"),
  '--wide': "(min-width: ".concat(_breakpoints["default"].wide, ")")
};